import { render, staticRenderFns } from "./BookingTourShape.vue?vue&type=template&id=3cd665d1&"
import script from "./BookingTourShape.vue?vue&type=script&lang=js&"
export * from "./BookingTourShape.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports